import React__default from 'react';
import './Skeleton.scss';

const SkeletonRect = ({ className, width, height, rounding = '12' }) => {
    const widthStyle = typeof width === 'number' ? `${width}px` : width;
    const heightStyle = typeof height === 'number' ? `${height}px` : height;
    return (React__default.createElement("div", { className: className, "data-rev-component": 'skeleton-rect', "data-rev-rounding": rounding, style: { width: widthStyle, height: heightStyle } }));
};
const SkeletonCircle = ({ className, size = 'medium' }) => {
    const getSizeStyle = () => {
        // Early return if size is a number
        if (typeof size === 'number')
            return { width: `${size}px`, height: `${size}px` };
        // No early return so let's try to map the size
        const sizeMap = {
            small: '24px',
            medium: '32px',
            large: '64px',
        };
        return {
            width: sizeMap[size],
            height: sizeMap[size],
        };
    };
    return (React__default.createElement("div", { "data-rev-component": 'skeleton-circle', className: className, style: getSizeStyle() }));
};
const SkeletonText = ({ className, textSize = 'body', numberOfLines = 1, }) => {
    // Calculate height based on size
    const getHeight = () => {
        // Early return if size is a number
        if (typeof textSize === 'number')
            return `${textSize}px`;
        // No early return so let's try to map the size
        // to a height
        const sizeMap = {
            page: 'calc(var(--rev-fontSize-jumbo) * var(--rev-lineHeight-heading))',
            section: 'calc(var(--rev-fontSize-sectionHeadline) * var(--rev-lineHeight-heading))',
            subsection: 'calc(var(--rev-fontSize-callout) * var(--rev-lineHeight-heading))',
            group: 'calc(var(--rev-fontSize-subtitle) * 1.3)',
            subgroup: 'calc(var(--rev-fontSize-bodyIncreased) * 1.4)',
            minor: 'calc(1rem * var(--rev-lineHeight-heading))',
            body: 'calc(1rem * var(--rev-lineHeight-base))',
            caption: 'calc(var(--rev-fontSize-caption) * var(--rev-lineHeight-base))',
        };
        // Return the mapped size if it exists, otherwise return
        // what was passed in in case it's something like `1.2rem`
        // or `2lh` etc.
        return sizeMap[textSize] || textSize;
    };
    // Generate random width for each line to simulate text rag
    const getRandomWidth = () => {
        const minPercentage = 50;
        const maxPercentage = 90;
        return `${Math.floor(Math.random() * (maxPercentage - minPercentage + 1)) + minPercentage}%`;
    };
    return (React__default.createElement("div", { "data-rev-component": 'skeleton-text', className: className }, Array.from({ length: numberOfLines }, (_, index) => (React__default.createElement(SkeletonRect, { key: index, width: getRandomWidth(), height: getHeight(), className: 'skeleton-text-line--rev' })))));
};

export { SkeletonCircle, SkeletonRect, SkeletonText };
//# sourceMappingURL=Skeleton.js.map
